import React from "react";
import { JWT } from "../shared";
import { AuthService } from "../services";
import { UserRoleType } from "../constants/Enum";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { routes } from "../constants/routes";

const PrivateRoutesAdmin = () => {
  const isValidToken = JWT.isValidToken();
  const loginUser = AuthService.getLoginUser();
  const location = useLocation();

  const setNavigation = () => {
    if (!loginUser && location?.pathname === routes.ADMIN_LOGIN) {
      return <Outlet />;
    } else if (
      !location?.pathname?.includes("login") &&
      location?.pathname?.startsWith("/admin")
    ) {
      if (loginUser) {
        // toast.warning("You don't have admin access.");
        return <Navigate to={routes.DEFAULT} />;
      } else return <Navigate to={routes.ADMIN_LOGIN} />;
    } else {
      return <Navigate to={routes.ADMIN_LOGIN} />;
    }
  };

  return isValidToken &&
    loginUser &&
    loginUser?.role === UserRoleType.UNKNOWN ? (
    <Outlet />
  ) : (
    setNavigation()
  );
};

export default PrivateRoutesAdmin;
